import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { DividentService } from 'src/app/services/divident.service';
import { AlertComponent } from 'src/app/structure/alert/alert.component';

@Component({
  selector: 'app-divident',
  templateUrl: './divident.component.html',
  styleUrls: ['./divident.component.css']
})
export class DividentComponent implements OnInit {

  dmForm: FormGroup;
  addBtn: boolean
  dmList: any = [];
  editDividendId: any;
  dividendMandateData: any;
  recordDate: { month: number; day: number; year: number; };
  dateOfBookClosure: { month: number; day: number; year: number; };
  dateOfDeclaration: { month: number; day: number; year: number; };
  dueDateOfPayment: { month: number; day: number; year: number; };
  dateOfTransfer: { month: number; day: number; year: number; };
  dateOfPayment: { month: number; day: number; year: number; };
  dateOfMandate: { month: number; day: number; year: number; };
  disabledOnclick: boolean;
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];


  constructor(private dividendmandateService: DividentService, private activatedRoute: ActivatedRoute,
    private alert: AlertComponent, private customValidation: CustomValidation,private router: Router) { }

  ngOnInit() {

    this.dmForm = new FormGroup({
      percDdec: new FormControl('', []),
      doBookClosure: new FormControl('', []),
      recordDate: new FormControl('', []),
      doDeclaration: new FormControl('', []),
      dueDpayDivident: new FormControl('', []),
      doTransferorOpenSeperateBA: new FormControl('', []),
      nameofMember: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z' ]*$"), this.customValidation.noWhitespaceValidator]),
      noOfSharesheld: new FormControl('', []),
      folioNumber: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9]*$"), this.customValidation.noWhitespaceValidator]),
      addresofMembers: new FormControl('', []),
      bankaccountnumber: new FormControl('', [Validators.minLength(8), Validators.maxLength(20)]),
      ifscOrOtherMandatoryInformation: new FormControl('', []),
      aoBBwhereDividendtobeCredited: new FormControl('', []),
      amountPaidontheShares: new FormControl('', []),
      dividendPayable: new FormControl('', []),
      dividendWarrantNumberFrom: new FormControl('', []),
      dividendWarrantNumberTo: new FormControl('', []),
      doPayment: new FormControl('', []),
      modeofPayment: new FormControl('', [Validators.pattern("^[a-zA-Z ]*$")]),
      interimDividend: new FormControl('', []),
      finalDividend: new FormControl('', []),
      dividendKeptinAbeyance: new FormControl('', []),
      nopToWhomDividendShoudbePaid: new FormControl('', [Validators.pattern("^[a-zA-Z0-9'.,& ]*$")]),
      doMandate: new FormControl('', []),
      courtOrderIfany: new FormControl('', []),
      remarks: new FormControl('', [])

    })

    this.activatedRoute.params.subscribe(params => {
      if (params['particularId'] != undefined) {
        this.addBtn = true;
        this.editDividendId = params['particularId'];
        this.getDividendMandateById(this.editDividendId);
      } else {
        this.addBtn = false;
      }
    }, err => {
      console.log("err ", err);
    })

  }
  back(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['dividendMandateList']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  getdmFormValues() {

    var dmFormobject = {
      percDdec: this.dmForm.controls.percDdec.value,
      doBookClosure: this.setDate(this.dmForm.controls.doBookClosure.value),
      recordDate: this.setDate(this.dmForm.controls.recordDate.value),
      doDeclaration: this.setDate(this.dmForm.controls.doDeclaration.value),
      dueDpayDivident: this.setDate(this.dmForm.controls.dueDpayDivident.value),
      doTransferorOpenSeperateBA: this.setDate(this.dmForm.controls.doTransferorOpenSeperateBA.value),
      nameofMember: this.dmForm.controls.nameofMember.value,
      noOfSharesheld: this.dmForm.controls.noOfSharesheld.value,
      folioNumber: this.dmForm.controls.folioNumber.value,
      addresofMembers: this.dmForm.controls.addresofMembers.value,
      baNumberwhereDividendtobeCredited: this.dmForm.controls.bankaccountnumber.value,
      ifscOrOtherMandatoryInformation: this.dmForm.controls.ifscOrOtherMandatoryInformation.value,
      aoBBwhereDividendtobeCredited: this.dmForm.controls.aoBBwhereDividendtobeCredited.value,
      amountPaidontheShares: this.dmForm.controls.amountPaidontheShares.value,
      dividendPayable: this.dmForm.controls.dividendPayable.value,
      dividendWarrantNumberFrom: this.dmForm.controls.dividendWarrantNumberFrom.value,
      dividendWarrantNumberTo: this.dmForm.controls.dividendWarrantNumberTo.value,
      doPayment: this.setDate(this.dmForm.controls.doPayment.value),
      modeofPayment: this.dmForm.controls.modeofPayment.value,
      interimDividend: this.dmForm.controls.interimDividend.value,
      finalDividend: this.dmForm.controls.finalDividend.value,
      dividendKeptinAbeyance: this.dmForm.controls.dividendKeptinAbeyance.value,
      nopToWhomDividendShoudbePaid: this.dmForm.controls.nopToWhomDividendShoudbePaid.value,
      doMandate: this.setDate(this.dmForm.controls.doMandate.value),
      courtOrderIfany: this.dmForm.controls.courtOrderIfany.value,
      remarks: this.dmForm.controls.remarks.value
    }
    return dmFormobject;
  }

  saveData() {
    this.disabledOnclick = true;
    var object = this.getdmFormValues();
    this.dividendmandateService.addDividendMandateData(object).subscribe(response => {
      this.disabledOnclick = false;
      if (response.status == 0) {
        this.alert.successWithOk(response.message, 'dividendMandateList');
      } else {
        if(response.err_fields){
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        }else{
          this.alert.error(response.message);
        }
      }
    }, err => {
      console.log("err ", err);
    })
  }

  getDividendMandateById(dividendId) {
    this.dividendmandateService.getDividendMandateById(dividendId).subscribe(response => {
      this.dividendMandateData = response.data[0];
      this.dmForm.controls.percDdec.setValue(this.dividendMandateData.percDdec);
      this.dmForm.controls.doBookClosure.setValue(this.dividendMandateData.doBookClosure);
      this.dmForm.controls.recordDate.setValue(this.dividendMandateData.recordDate);
      this.dmForm.controls.doDeclaration.setValue(this.dividendMandateData.doDeclaration);
      this.dmForm.controls.dueDpayDivident.setValue(this.dividendMandateData.dueDpayDivident);
      this.dmForm.controls.doTransferorOpenSeperateBA.setValue(this.dividendMandateData.doTransferorOpenSeperateBA);
      this.dmForm.controls.nameofMember.setValue(this.dividendMandateData.nameofMember);
      this.dmForm.controls.noOfSharesheld.setValue(this.dividendMandateData.noOfSharesheld);
      this.dmForm.controls.folioNumber.setValue(this.dividendMandateData.folioNumber);
      this.dmForm.controls.addresofMembers.setValue(this.dividendMandateData.addresofMembers);
      this.dmForm.controls.bankaccountnumber.setValue(this.dividendMandateData.baNumberwhereDividendtobeCredited);
      this.dmForm.controls.ifscOrOtherMandatoryInformation.setValue(this.dividendMandateData.ifscOrOtherMandatoryInformation);
      this.dmForm.controls.aoBBwhereDividendtobeCredited.setValue(this.dividendMandateData.aoBBwhereDividendtobeCredited);
      this.dmForm.controls.amountPaidontheShares.setValue(this.dividendMandateData.amountPaidontheShares);
      this.dmForm.controls.dividendPayable.setValue(this.dividendMandateData.dividendPayable);
      this.dmForm.controls.dividendWarrantNumberFrom.setValue(this.dividendMandateData.dividendWarrantNumberFrom);
      this.dmForm.controls.dividendWarrantNumberTo.setValue(this.dividendMandateData.dividendWarrantNumberTo);
      this.dmForm.controls.doPayment.setValue(this.dividendMandateData.doPayment);
      this.dmForm.controls.modeofPayment.setValue(this.dividendMandateData.modeofPayment);
      this.dmForm.controls.interimDividend.setValue(this.dividendMandateData.interimDividend);
      this.dmForm.controls.finalDividend.setValue(this.dividendMandateData.finalDividend);
      this.dmForm.controls.dividendKeptinAbeyance.setValue(this.dividendMandateData.dividendKeptinAbeyance);
      this.dmForm.controls.nopToWhomDividendShoudbePaid.setValue(this.dividendMandateData.nopToWhomDividendShoudbePaid);
      this.dmForm.controls.doMandate.setValue(this.dividendMandateData.doMandate);
      this.dmForm.controls.courtOrderIfany.setValue(this.dividendMandateData.courtOrderIfany);
      this.dmForm.controls.remarks.setValue(this.dividendMandateData.remarks);

      if (this.dividendMandateData.doBookClosure != null) {
        let dt = new Date(this.setFormatDate(this.dividendMandateData.doBookClosure));
        this.dateOfBookClosure = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.dividendMandateData.recordDate != null) {
        let dt = new Date(this.setFormatDate(this.dividendMandateData.recordDate));
        this.recordDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.dividendMandateData.doDeclaration != null) {
        let dt = new Date(this.setFormatDate(this.dividendMandateData.doDeclaration));
        this.dateOfDeclaration = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.dividendMandateData.dueDpayDivident != null) {
        let dt = new Date(this.setFormatDate(this.dividendMandateData.dueDpayDivident));
        this.dueDateOfPayment = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.dividendMandateData.doTransferorOpenSeperateBA != null) {
        let dt = new Date(this.setFormatDate(this.dividendMandateData.doTransferorOpenSeperateBA));
        this.dateOfTransfer = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.dividendMandateData.doPayment != null) {
        let dt = new Date(this.setFormatDate(this.dividendMandateData.doPayment));
        this.dateOfPayment = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.dividendMandateData.doMandate != null) {
        let dt = new Date(this.setFormatDate(this.dividendMandateData.doMandate));
        this.dateOfMandate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
    }, err => {
      console.log("err ", err);
    })
  }

  updateData() {
    this.disabledOnclick = true;
    var object = this.getdmFormValues();
    this.dividendmandateService.updateDividendMandate(object, this.editDividendId).subscribe(response => {
      this.disabledOnclick = false;
      if (response.status == 0) {
        this.alert.successWithOk(response.message, 'dividendMandateList');
      } else {
        if(response.err_fields){
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        }else{
          this.alert.error(response.message);
        }
      }
    }, err => {
      console.log("err ", err);
    })

  }

  generateOutput() {
    var object = {
      id: this.editDividendId,
      fromDate:null,
      toDate:null,
      name:null
    }
    this.dividendmandateService.generateDividendMandateDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(self.editDividendId);
          setTimeout(function () {
            self.downloadPdfDocument(self.editDividendId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.dividendmandateService.downloadDividendMandateFile(id, 'Single');
  }
  downloadPdfDocument(id) {
    this.dividendmandateService.downloadDividendMandatePdfFile(id, 'Single');
  }
}
